import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const UserListSlice = createSlice({
    name: "userList",
    initialState,
    reducers: {
        getUserListRequest(state) {
            state.loading = true;
        },
        getUserListRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getUserListRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getUserListRequest,
    getUserListRequestSuccess,
    getUserListRequestError,
} = UserListSlice.actions;

export default UserListSlice.reducer;
